import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import BackButton from "../../img/icons/icon_blue_back.svg";
import Address from "../../components/address";
import { parseNumberFromAnotherLocale } from "../../utils";

function UpdatePinNumber({ initState = null }) {
  const history = useHistory();
  const { t } = useTranslation();

  // update pin code number
  const changePinNumber = async (pin, address) => {
    const token = "Bearer " + localStorage.getItem("token");
    const patientId = JSON.parse(localStorage.getItem("pid"));
    const PATCH_URL = `/api/v1/users/profile/${patientId}`;
    try {
      const data = {
        zipCode: parseNumberFromAnotherLocale(pin),
        location: address,
      };
      const response = await fetch(`${PATCH_URL}`, {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=utf-8",
          Authorization: token.replace(/['"]+/g, ""),
        },
        body: JSON.stringify(data),
        credentials: "include",
      });
      const res = await response.json();
      console.log(res);

      if (!response.status === 200) {
        const error = new Error(response.error);
        throw error;
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleClick = (pin, address) => {
    changePinNumber(pin, address);
    history.push("/setting");
  };

  const onNextFn = (data) => {
    console.log(data);
    handleClick(data["pin"], data["text"]);
  };

  return (
    <>
      <header className="border_bottom">
        <div className="inner_header">
          <Link to="/setting" className="icon_left d-flex align-items-center">
            <img src={BackButton} alt="" className="img-fluid" />
            <span className="head_title">{t("sidenav.ADDRESS.detail")}</span>
          </Link>
        </div>
      </header>
      <Address initState={null} onSubmitHandler={onNextFn} />
      <div className="custom_modal modal fade text-center" id="modal_pin">
        <div className="modal-dialog d-flex align-items-center top-0">
          <div className="modal-content">
            <div className="modal-header border-bottom-0">
              <button
                id="modal_pin"
                type="button"
                className="btn-close btn-dark-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="content_modal text-start p-2">
                <h3 className="maintitle maintitle_txt_color_black text-center pb-3">
                  {t("sidenav.ADDRESS.message2")}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UpdatePinNumber;
